<template>
	<div class="container">
		<h1>API 接口测试</h1>
		<div v-for="(testCase, index) in testCases" :key="index" class="test-case">
			<h3>{{ testCase.name }}</h3>
			<div class="result" :class="{ error: testCase.error }">
				<div v-if="testCase.loading">Loading...</div>
				<div v-else>
					<strong>Status:</strong>
					<span :class="testCase.success ? 'success' : 'fail'">
						{{ testCase.success ? '✅ 成功' : '❌ 失败' }}
					</span>
					<pre v-if="testCase.response">{{ testCase.response }}</pre>
					<div v-if="testCase.error" class="error-message">
						<strong>Error:</strong>
						{{ testCase.error }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as api from '../netTool/api.js';

export default {
	name: 'ApiTester',
	data() {
		return {
			testCases: [
				{
					name: 'achievementApi.getAchievementList',
					call: () => api.achievementApi.getAchievementList(),
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'bannerApi.getBanner',
					call: () => api.bannerApi.getBanner(1),
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'brandStoreApi.getBrandStores',
					call: () => api.brandStoreApi.getBrandStores({}),
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'footerInfoApi.getFooterData',
					call: () => api.footerInfoApi.getFooterData(),
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{ name: 'homeNewsApi.getAllHomeNews', call: () => api.homeNewsApi.getAllHomeNews(), loading: true, success: false, response: null, error: null },
				{ name: 'homeProductApi.getAllHomeProducts', call: () => api.homeProductApi.getAllHomeProducts(), loading: true, success: false, response: null, error: null },
				{ name: 'newsApi.getNewsList', call: () => api.newsApi.getNewsList(), loading: true, success: false, response: null, error: null },
				{
					name: 'newsApi.getNewsById',
					call: () => api.newsApi.getNewsById(1), // 示例使用 id=1
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'productApi.getProductList',
					call: () => api.productApi.getProductList(),
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'productApi.getProductById',
					call: () => api.productApi.getProductById(1), // 示例使用 id=1
					loading: true,
					success: false,
					response: null,
					error: null
				},
				{
					name: 'sceneApi.getSceneList',
					call: () => api.sceneApi.getSceneList(),
					loading: true,
					success: false,
					response: null,
					error: null
				}
			]
		};
	},
	mounted() {
		this.runTests();
	},
	methods: {
		async runTests() {
			for (const testCase of this.testCases) {
				try {
					const response = await testCase.call();
					testCase.loading = false;
					testCase.success = response.success;
					testCase.response = JSON.stringify(response, null, 2);
				} catch (error) {
					testCase.loading = false;
					testCase.error = error.message;
				}
			}
		}
	}
};
</script>

<style scoped>
.container {
	font-family: Arial, sans-serif;
	padding: 20px;
	max-width: 1200px;
	margin: 0 auto;
}

.test-case {
	margin-bottom: 30px;
	border: 1px solid #ddd;
	padding: 15px;
	border-radius: 5px;
	background: white;
}

.result {
	background: #f5f5f5;
	padding: 10px;
	margin-top: 10px;
	white-space: pre-wrap;
	border-radius: 3px;
}

pre {
	margin: 10px 0 0;
	background: #f8f8f8;
	padding: 10px;
	border-radius: 3px;
	overflow-x: auto;
}

.error-message {
	color: #dc3545;
	margin-top: 10px;
}

.success {
	color: #28a745;
}

.fail {
	color: #dc3545;
}

h3 {
	color: #2c3e50;
	margin-bottom: 10px;
}
</style>
